import { WidgetType } from './widgetType';
export const InteractiveTabsHelper = {
    isInteractiveTabsWidget: (widget) => {
        return widget.value.type === WidgetType.interactiveTabs;
    },
    isInteractiveTabsServerData: (widget) => {
        return widget.type === WidgetType.interactiveTabs;
    },
    makeDefaultProperties: () => {
        return {
            displayDelayInSeconds: 0,
            isRequired: false,
        };
    },
};
